import React from "react";
import "../../../styles/faq.scss";
import { t } from "../../../../../utils/i18n";

const FaqSection = () => {
  return (
    <div id="accordion" className="tradedetail-accordion">
      <h4 className="trade-faq-title" title={t("p2p.faq.title")}>
        {t("p2p.faq.heading")}
        <i className="fas fa-question-circle"></i>
      </h4>
      <div className="trade-faq-card">
        <a className="trade-faq-header" data-toggle="collapse" href="#collapseOne">
          {t("p2p.faq.q1")}
        </a>
        <div
          id="collapseOne"
          className="collapse"
          data-parent="#accordion"
        >
          <div className="card-body">
            <ol>
              <li dangerouslySetInnerHTML={{ __html: t("p2p.faq.q1_a1_html") }} />
              <li dangerouslySetInnerHTML={{ __html: t("p2p.faq.q1_a2_html") }} />
              <li dangerouslySetInnerHTML={{ __html: t("p2p.faq.q1_a3_html") }} />
            </ol>
          </div>
        </div>
      </div>
      <div className="trade-faq-card">
        <a
          className="collapsed trade-faq-header"
          data-toggle="collapse"
          href="#collapseTwo"
        >
          {t("p2p.faq.q2")}
        </a>
        <div id="collapseTwo" className="collapse" data-parent="#accordion">
          <div className="card-body">
            {t("p2p.faq.a2")}
          </div>
        </div>
      </div>
      <div className="trade-faq-card">
        <a
          className="collapsed trade-faq-header"
          data-toggle="collapse"
          href="#collapseThree"
        >
          {t("p2p.faq.q3")}
        </a>
        <div id="collapseThree" className="collapse" data-parent="#accordion">
          <div className="card-body">
            {t("p2p.faq.a3")}
          </div>
        </div>
      </div>
      <div className="trade-faq-card">
        <a
          className="collapsed trade-faq-header"
          data-toggle="collapse"
          href="#collapseFour"
        >
          {t("p2p.faq.q4")}
        </a>
        <div id="collapseFour" className="collapse" data-parent="#accordion">
          <div className="card-body">
            {t("p2p.faq.a4")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqSection;
